<template>
  <transition name="fade" mode="out-in" appear class="backdropModal">
    <slot />
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out, background-color 0.1s ease-in-out, backdrop-filter 0.1s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  background-color: transparent;
}

.backdropModal {
  background-color: var(--modal-background, rgba(46, 46, 46, 0.5));
  backdrop-filter: blur(5px);
}
</style>
